
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import { EventEmitter } from 'events';

@Component({})
export default class Alert extends Vue {
  @Prop({ default: 'info' }) variant!: 'info' | 'error' | 'success';
  @Prop({ default: false }) visible!: boolean;
  @Prop({ default: false }) dismissible!: boolean;
  /**
   * alertへのイベントリクエスト。
   *
   * 'shake' - アラートを横揺れさせるアニメーションをトリガーします。
   *
   * 'updateHeight' - アラートの高さを更新します。
   */
  @Prop() shakeAnimationEmitter?: EventEmitter;
  private height = 100;
  get wrapperClasses() {
    return {
      'alert-wrapper': true,
      opened: this.visible,
      closed: !this.visible,
    };
  }

  get wrapperStyles() {
    return {
      height: this.visible ? `${this.height}px` : '0px',
      opacity: this.visible ? 1 : 0,
      overflow: this.visible ? 'visible' : 'hidden',
    };
  }

  get containerClasses() {
    return {
      alert: true,
      'alert-info': this.variant === 'info',
      'alert-error': this.variant === 'error',
      'alert-success': this.variant === 'success',
    };
  }

  get containerStyles() {
    return {
      'padding-right': this.dismissible ? '32px' : undefined,
    };
  }

  get dissmissButtonClasses() {
    return {
      info: this.variant === 'info',
      error: this.variant === 'error',
      success: this.variant === 'success',
    };
  }

  mounted() {
    if (this.shakeAnimationEmitter) {
      this.shakeAnimationEmitter.addListener('shake', this.shake);
    }
    this.resizeAlert();
    window.addEventListener('resize', this.resizeAlert);
  }

  beforeDestroy() {
    if (this.shakeAnimationEmitter) {
      this.shakeAnimationEmitter.removeListener('shake', this.shake);
    }
    window.removeEventListener('resize', this.resizeAlert);
  }

  shake() {
    const keyframes = [
      { transform: 'translateX(0)' },
      { transform: 'translateX(5px)' },
      { transform: 'translateX(-5px)' },
      { transform: 'translateX(5px)' },
      { transform: 'translateX(0)' },
    ];
    const option = {
      duration: 300,
    };
    const containerRef = this.$refs.containerRef as HTMLDivElement;
    containerRef.animate(keyframes, option);
  }

  resizeAlert() {
    //高さの変化アニメーションにおいては高さを指定しなければならないので、高さを取得して設定する。（ウィンドウサイズが変化してはみ出ないように変化時に更新する）
    const containerRef = this.$refs.containerRef as HTMLDivElement;
    this.height = containerRef.offsetHeight + 30;
  }

  @Emit('dissmiss')
  dissmiss() {}
}
